<template>
  <article class="article-card" @click="goToArticle">
    <div class="card-meta">
      <span class="card-category" v-if="article.category">{{ article.category.name }}</span>
      <span class="card-date">{{ formatDate(article.published_at || article.created_at) }}</span>
    </div>
    <h3 class="card-title">{{ article.title }}</h3>
    <p class="card-summary">{{ article.summary }}</p>
    <div class="card-footer">
      <span class="card-stats">
        <span class="card-views">
          <i class="el-icon-view"></i> {{ article.view_count }}
        </span>
      </span>
      <span class="card-read">阅读全文 →</span>
    </div>
    <div class="card-tags" v-if="article.tags && article.tags.length">
      <span class="card-tag" v-for="tag in article.tags" :key="tag.id">{{ tag.name }}</span>
    </div>
  </article>
</template>

<script>
export default {
  name: 'ArticleCard',
  props: { article: { type: Object, required: true } },
  methods: {
    goToArticle() { this.$router.push(`/article/${this.article.slug}`) },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
    }
  }
}
</script>

<style scoped>
.article-card {
  background: var(--blog-bg-elevated);
  border: 1px solid var(--blog-border);
  border-radius: 0.75rem;
  padding: 1.5rem;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}
.article-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-md);
  border-color: var(--blog-accent);
}
.card-meta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}
.card-category {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  font-weight: 500;
  color: var(--blog-accent);
  background: var(--blog-accent-subtle);
  padding: 0.15rem 0.5rem;
  border-radius: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.card-date {
  font-size: 0.8rem;
  color: var(--blog-text-3);
}
.card-title {
  font-family: var(--font-display);
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.35;
  color: var(--blog-text);
  margin-bottom: 0.5rem;
  transition: color 0.15s;
  letter-spacing: -0.01em;
}
.article-card:hover .card-title { color: var(--blog-accent); }
.card-summary {
  font-size: 0.875rem;
  color: var(--blog-text-2);
  line-height: 1.65;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 0.75rem;
}
.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.75rem;
  border-top: 1px solid var(--blog-border-light);
}
.card-stats {
  font-size: 0.75rem;
  color: var(--blog-text-3);
  display: flex;
  gap: 1rem;
}
.card-views i { margin-right: 2px; color: var(--blog-accent); }
.card-read {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--blog-accent);
}
.card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 0.75rem;
}
.card-tag {
  font-family: var(--font-mono);
  font-size: 0.7rem;
  color: var(--blog-text-2);
  background: var(--blog-bg-secondary);
  padding: 0.15rem 0.6rem;
  border-radius: 1rem;
  border: 1px solid var(--blog-border);
}
</style>
